var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_3509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6668 8.00004C14.6668 8.87552 14.4944 9.74243 14.1594 10.5513C13.8243 11.3601 13.3333 12.095 12.7142 12.7141C12.0952 13.3331 11.3602 13.8242 10.5514 14.1592C9.74255 14.4943 8.87564 14.6667 8.00016 14.6667C7.12468 14.6667 6.25778 14.4943 5.44894 14.1592C4.6401 13.8242 3.90517 13.3331 3.28612 12.7141C2.66706 12.095 2.176 11.3601 1.84097 10.5513C1.50593 9.74243 1.3335 8.87552 1.3335 8.00004C1.3335 7.12456 1.50593 6.25765 1.84097 5.44882C2.176 4.63998 2.66706 3.90505 3.28612 3.28599C3.90518 2.66694 4.6401 2.17587 5.44894 1.84084C6.25778 1.50581 7.12468 1.33337 8.00016 1.33337C8.87564 1.33337 9.74255 1.50581 10.5514 1.84084C11.3602 2.17588 12.0952 2.66694 12.7142 3.286C13.3333 3.90505 13.8243 4.63998 14.1594 5.44882C14.4944 6.25766 14.6668 7.12456 14.6668 8.00004L14.6668 8.00004Z",
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6668 8.00004C10.6668 8.87552 10.5979 9.74243 10.4638 10.5513C10.3298 11.3601 10.1334 12.095 9.88578 12.7141C9.63816 13.3331 9.34419 13.8242 9.02065 14.1592C8.69712 14.4943 8.35035 14.6667 8.00016 14.6667C7.64997 14.6667 7.30321 14.4943 6.97967 14.1592C6.65614 13.8242 6.36217 13.3331 6.11454 12.7141C5.86692 12.095 5.6705 11.3601 5.53648 10.5513C5.40247 9.74243 5.3335 8.87552 5.3335 8.00004C5.3335 7.12456 5.40247 6.25765 5.53648 5.44882C5.6705 4.63998 5.86692 3.90505 6.11454 3.28599C6.36217 2.66694 6.65614 2.17587 6.97967 1.84084C7.30321 1.50581 7.64997 1.33337 8.00016 1.33337C8.35035 1.33337 8.69712 1.50581 9.02065 1.84084C9.34419 2.17588 9.63816 2.66694 9.88578 3.286C10.1334 3.90505 10.3298 4.63998 10.4638 5.44882C10.5979 6.25766 10.6668 7.12456 10.6668 8.00004L10.6668 8.00004Z",
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 8H14.6668",
    stroke: "#333333",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_3509"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.65a72fb76c37da74944c245699ea2cec.svg";
export { ForwardRef as ReactComponent };